import clsx from 'clsx';
import React, { FC } from 'react';

import { getFormattedPrice } from '../../helpers/price';

interface BaseTotalTableProps {
  data: {
    id: string;
    name: string;
    currencyAmount: number;
    currency: string;
    course: number;
    rublesAmount: number;
  }[];
}

const BaseTotalTable: FC<BaseTotalTableProps> = ({ data }) => {
  return (
    <>
      {data.map((item, index) => (
        <React.Fragment key={`${item.id}-${index}`}>
          <div
            className={clsx('no-left-border', {
              'customs-payments-base-total': data.length - 1 === index,
            })}
          >
            {item.name}
          </div>
          {data.length - 1 !== index && (
            <div className="center">
              {getFormattedPrice(item.currencyAmount, 2)} {item.currency}
            </div>
          )}
          {data.length - 1 !== index && <div className="center">{item.course}</div>}
          <div className="center">{getFormattedPrice(item.rublesAmount, 2)} RUB</div>
        </React.Fragment>
      ))}
    </>
  );
};

export default BaseTotalTable;
